import { render, staticRenderFns } from "./achievementSetting.vue?vue&type=template&id=6a3931f0&scoped=true&"
import script from "./achievementSetting.vue?vue&type=script&lang=js&"
export * from "./achievementSetting.vue?vue&type=script&lang=js&"
import style0 from "./achievementSetting.vue?vue&type=style&index=0&id=6a3931f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3931f0",
  null
  
)

export default component.exports